import {getAuthenticatedThemisClient} from '@modifi/onboarding-api-clients'
import {updateFactory, Reducer} from '@modifi/redux'
import {aPush} from '@modifi/router'
import {aCloseDialog} from '@modifi/plugin-dialogs'
import {aFetchSellerBankAccounts} from '../../data/seller-bank-accounts'
import {aFetchInputFields} from '../../data/input-fields'
import {aFetchFinancingOptions} from '../../data/financing-options'
import {ROUTE_COMPANY_PROFILE_BANK_DETAILS} from '../../routes/constants'

const apiClient = getAuthenticatedThemisClient()

const {actions, selectors, reducer} = updateFactory({
  rootSelector: state => state?.features?.deleteSellerBankAccount,
  actionNamePrefix: 'features/seller-bank-account/delete',
  submitRequest:
    (a, externalBankAccountId: string) =>
    // eslint-disable-next-line consistent-return
    async (dispatch): Promise<any> => {
      dispatch(a.pendingAction())
      try {
        await apiClient.SellerBankAccounts.delete({externalBankAccountId})
      } catch (error: any) {
        dispatch(a.errorAction(error))
        return null
      }
      dispatch(a.successAction())
      dispatch(aCloseDialog())
      // refetch company to get possibly updated financing options
      await Promise.all([
        dispatch(aFetchSellerBankAccounts()),
        dispatch(aFetchFinancingOptions()),
        dispatch(aFetchInputFields()),
      ])
      await dispatch(aPush(ROUTE_COMPANY_PROFILE_BANK_DETAILS))
    },
})

export default reducer as Reducer

export const {aSubmit: aDeleteSellerBankAccount, aReset: aResetDeleteSellerBankAccount} = actions

export const {
  selectUpdatePending: selectDeleteIsPending,
  selectUpdateErrorMessage: selectDeleteErrorMessage,
} = selectors
